module.exports = __webpack_public_path__ + "img/filter.8adb55a2.svg";